import { render } from "./LyricsSoundOfHeaven.vue?vue&type=template&id=61fc0805&scoped=true"
import script from "./LyricsSoundOfHeaven.vue?vue&type=script&lang=js"
export * from "./LyricsSoundOfHeaven.vue?vue&type=script&lang=js"

import "./LyricsSoundOfHeaven.vue?vue&type=style&index=0&id=61fc0805&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fc0805"]])

export default __exports__